@if (icon) {
<div class="-card-category-product-asset">
  <app-link [to]="to"><lucide-icon [name]="icon" class="card-category-icon"></lucide-icon></app-link> 
</div>
}
<a [attr.href]="totype === 'card' ? to ? to : null : null" [target]="template === 'external' ? '_blank' : '_self'">
  <div class="card-product -title" [ngClass]="totype === 'card' ? '' : '-header-link'">
    <div class="-subtitle -fontDisplayThin">{{subtitle}}</div>
    <div class="-title-card-category-product">
      @if (totype === 'title') {
        <app-link [to]="to"><h3>{{title}}</h3></app-link>
      }
      @if (totype === 'card') {
        <h3>{{title}}</h3>
      }
      @if (version) {
        <version-pill [label]="version"></version-pill>
      }
    </div>
  </div>
  <ng-content></ng-content>
</a>